import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { handleFormErrorOrModal } from 'sh-www/utils/handles-errors';

const FORM_INPUTS = [
  'primary_reason',
  'secondary_reason',
  'primary_text',
  'secondary_text',
  'additional_information',
];

export default class PostingCloseController extends Controller {
  @service router;
  @service session;

  @service('state-managers/application')
  applicationStateManager; 

  @service('commands/assignment-commands')
  assignmentCommandService;

  selectedReason = '';
  elsewhereReason = '';
  otherReasonText = '';
  otherPlatformText = '';
  additionalInfo = '';
  errors = {};

  @computed('selectedReason','elsewhereReason','otherReasonText','otherPlatformText','closeAssignmentTask.isRunning')
  get isSubmitDisabled () {
    if (!this.selectedReason || this.closeAssignmentTask.isRunning) {
      return true;
    }

    if (this.selectedReason === 'other' && !this.otherReasonText) {
      return true;
    }

    if (this.selectedReason === 'found_freelancer_elsewhere') {
      if (!this.elsewhereReason || (this.elsewhereReason === 'other_platform' && !this.otherPlatformText)) {
        return true;
      }
    }

    return false;
  }

  @action
  onReasonClicked(reason) {
    const newValue = this.selectedReason === reason ? '' : reason;
    this.setProperties({
      selectedReason: newValue,
      otherReasonText: '',
      otherPlatformText: '',
      elsewhereReason: ''
    });
  }

  @action
  onElsewhereReasonClicked(reason) {
    const newValue = this.elsewhereReason === reason ? '' : reason;
    this.setProperties({
      elsewhereReason: newValue,
      otherReasonText: '',
      otherPlatformText: ''
    });
  }

  @action
  onTextFieldInput(field, value) {
    this.set(field, value);
  }

  @action
  onCancelClicked() {
    window.history.back();
  }

  @action
  onSubmitClicked() {
    this.set('errors', {});

    const assignment = this.model;
    const feedback = {
      primary_reason: this.selectedReason,
      secondary_reason: this.elsewhereReason,
      primary_text: this.otherReasonText,
      secondary_text: this.otherPlatformText,
      additional_information: this.additionalInfo,
    }

    this.closeAssignmentTask.perform(assignment, feedback);
  }

  resetController() {
    this.setProperties({
      selectedReason: '',
      elsewhereReason: '',
      otherReasonText: '',
      otherPlatformText: '',
      additionalInfo: '',
      errors: {},
    });
  }

  @dropTask
  *closeAssignmentTask(assignment, feedback) {
    try {
      const updatedAssignment = yield this.assignmentCommandService.closeAssignmentSubmissions(assignment, feedback);
      this.applicationStateManager.addToast('Posting successfuly closed');
      const route = this.session.currentUser.isAdmin ? EMBER_ROUTE_NAMES.POSTING__INDEX : EMBER_ROUTE_NAMES.POSTING__PENDING;
      yield this.router.transitionTo(route, updatedAssignment.idWithSlug);
    } catch (error) {
      handleFormErrorOrModal(this, error, FORM_INPUTS, true);
    }
  }
}
